import { initialReducerState } from '../constants'

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'filterData':
      return { ...state, filterData: payload }
    case 'chartData':
      return { ...state, chartData: payload }
    case 'tableData':
      return { ...state, tableData: payload }
    case 'todayData':
      return { ...state, todayData: payload }
    default:
      return initialReducerState
  }
}

export {
  reducer,
  initialReducerState
}
